/**
 * Session cache for the Jobs list (paginated / filtered) so navigating away from Jobs
 * does not refetch the same query. Single-slot; cleared on logout and when data changes.
 */
let cached = null;

export function getJobsListCacheKey(filters, page, rowsPerPage, debouncedSearch) {
  return JSON.stringify({
    st: filters.status ?? "",
    sd: filters.startDate ?? "",
    ed: filters.endDate ?? "",
    p: page,
    r: rowsPerPage,
    q: (debouncedSearch && debouncedSearch.trim()) || "",
  });
}

export function readJobsListCache(key) {
  if (!cached || cached.key !== key) return null;
  return {
    jobs: cached.jobs,
    totalJobs: cached.totalJobs,
  };
}

export function writeJobsListCache(key, jobs, totalJobs) {
  cached = {
    key,
    jobs,
    totalJobs,
  };
}

export function invalidateJobsListCache() {
  cached = null;
}
